export default __webpack_public_path__ + "static/914-986d9ab4585e1f629bfa82f3e7d1d0da.gif";